import { FarmContacts } from 'types/FarmData';
import { FC } from 'react';
import { FarmContactsWrapper } from './style';

interface Props {
  contacts: FarmContacts[] | undefined;
}

const Contacts: FC<Props> = ({ contacts }) => {
  const filteredContacts = contacts?.filter(
    (contact) => contact.status !== false
  );

  return (
    <FarmContactsWrapper className="farm-contacts">
      {filteredContacts &&
        filteredContacts.map((contact) => {
          const contactInfo = [
            contact.full_name,
            contact.contact_phone,
            contact.contact_email,
            contact.role,
          ]
            .filter(Boolean) // removes any null, undefined, "", or false values
            .join(', ');

          return (
            <div className="contact-item" key={contact.id}>
              {contactInfo}
            </div>
          );
        })}
    </FarmContactsWrapper>
  );
};

export default Contacts;
